var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'operations-modal',
        {
            '--open': _vm.open
        }
    ]},[_c('b-sidebar',{attrs:{"id":"operations-modal","visible":_vm.open,"shadow":"","right":"","bg-variant":"white","backdrop":"","no-close-on-backdrop":"","no-close-on-esc":""},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('Header')]},proxy:true},{key:"footer",fn:function(){return [_c('Footer')]},proxy:true}])},[[_c('Content')]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }